export default __webpack_public_path__ + "images/4b086dcc13b5f6edcc8272621684f1a5.png";